import { createSlice } from "@reduxjs/toolkit";

export const categorySlice = createSlice({
  name: "create-category",
  initialState: {
    categoryData: [],
    error: {},
    message: "",
  },
  reducers: {
    onGetCategoryAll: (state) => {
      return {
        ...state,
        categoryData: [],
        error: {},
        message: "",
        isLoading:true
      };
    },

    onGetCategoryAllSuccess: (state, { payload }) => {
      const { data = [], message = "", status_code = 200 } = payload;
      const categoryData = Array.isArray(data?.categories)
        ? data.categories
        : Array.isArray(data)
          ? data
          : [];
      return {
        ...state,
        categoryData: categoryData.filter(
          (category) => category?.enabled !== false && category?.deleted !== true
        ),
        message,
        status_code,
        error: {},
        isLoading:false
      };
    },

    onGetCategoryAllError: (state, { payload }) => {
      const { message = "", status_code = 400 } = payload;
      return {
        ...state,
        categoryData:[],
        message,
        status_code,
        error: {},
        isLoading:false
      };
    }
  },
});
export const { 
  onGetCategoryAll,
  onGetCategoryAllSuccess,
  onGetCategoryAllError
} = categorySlice.actions;

export default categorySlice.reducer;
